






























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import ArticleCategory from "../../../store/entities/articles/article-category";
@Component({
  components: {}
})
export default class CreateCate extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  cate: ArticleCategory = new ArticleCategory();

  
  save() {
    (this.$refs.cateForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "articleCategory/create",
          data: this.cate
        });
        (this.$refs.cateForm as any).resetFields();
        
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.cateForm as any).resetFields();
    
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cateRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("CategoryName")),
        trigger: "blur"
      }
    ]
  };
}
